var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStopBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.5C5.7075 0.5 3.63891 1.46558 2.1816 3.00941C0.830019 4.44124 0 6.37477 0 8.5C0 12.9183 3.58172 16.5 8 16.5C10.1252 16.5 12.0588 15.67 13.4906 14.3184C15.0344 12.8611 16 10.7925 16 8.5C16 4.08172 12.4183 0.5 8 0.5ZM12.7689 12.1418L4.35824 3.73109C5.36849 2.95819 6.63022 2.5 8 2.5C11.3137 2.5 14 5.18629 14 8.5C14 9.86978 13.5418 11.1315 12.7689 12.1418ZM2.99229 5.19356L11.3064 13.5077C10.3583 14.1352 9.22239 14.5 8 14.5C4.68629 14.5 2 11.8137 2 8.5C2 7.27761 2.36477 6.14169 2.99229 5.19356Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStopBlack);
export default __webpack_public_path__ + "static/media/icon_stop_black.3219d9e82605309de0da1dedeaa8a292.svg";
export { ForwardRef as ReactComponent };